import { createSelector } from 'reselect';
import ClientEmptyState from './GoalCarouselClientEmptyState';

export const goalCarouselSelector = state => state.GoalCarousel;
export const clientIdSelector = (state, props) => props.clientId;
export const fpIdSelector = (state, props) => props.fpId;
export const capsuleIdSelector = (state, props) => props.capsuleId;
export const proposedPlanSelector = (state, props) => props.proposed_plan;
export const isCurrentPlanSelector = (state, props) => props.isCurrent;

export const clientGoalCarouselSelector = createSelector(
  goalCarouselSelector,
  clientIdSelector,
  (goalCarousel, clientId) => goalCarousel[clientId] || ClientEmptyState,
);

export const currentGoalIndexSelector = createSelector(
  clientGoalCarouselSelector,
  clientGoalCarousel => clientGoalCarousel.currentGoalIndex,
);

export const goalsListSelector = createSelector(
  clientGoalCarouselSelector,
  clientGoalCarousel => clientGoalCarousel.goalsList,
);

export const initialFpIdSelector = createSelector(
  clientGoalCarouselSelector,
  clientGoalCarousel => clientGoalCarousel.initialFpId,
);

export const isInitializedSelector = createSelector(
  goalsListSelector,
  goalsList => goalsList.length > 0,
);

export const currentGoalDataSelector = createSelector(
  goalsListSelector,
  currentGoalIndexSelector,
  (goalsList, currentGoalIndex) => goalsList.find(goal => goal.index === currentGoalIndex),
);

export const initialChartDataSelector = createSelector(
  clientGoalCarouselSelector,
  currentGoalDataSelector,
  fpIdSelector,
  initialFpIdSelector,
  (clientGoalCarousel, currentGoalData, fpId, initialFpId) => {
    if (fpId !== initialFpId) {
      return null;
    }

    if (!currentGoalData || currentGoalData.id !== clientGoalCarousel.initialGoalData.id) {
      return null;
    }

    return clientGoalCarousel.initialGoalData.chart;
  },
);
